import type { ResolvedBuilding } from '$lib/types'

/**
 * Per-import resolver cache. Keyed by `(importedCityId|cityentityId)` so that
 * resolving the same entity across renders is O(1). The reference-catalogue-only
 * branch shares a separate bucket.
 */
const REFERENCE_BUCKET = '__ref__'

const memo = new Map<string, ResolvedBuilding | null>()

function key(entityId: string, importedCityId: number | typeof REFERENCE_BUCKET): string {
  return `${importedCityId}|${entityId}`
}

export function getCached(
  entityId: string,
  importedCityId: number | undefined,
): { hit: boolean; value: ResolvedBuilding | null } {
  const k = key(entityId, importedCityId ?? REFERENCE_BUCKET)
  if (memo.has(k)) return { hit: true, value: memo.get(k) ?? null }
  return { hit: false, value: null }
}

export function setCached(
  entityId: string,
  importedCityId: number | undefined,
  value: ResolvedBuilding | null,
): void {
  memo.set(key(entityId, importedCityId ?? REFERENCE_BUCKET), value)
}

export function clearCache(): void {
  memo.clear()
}

export function invalidateImport(importedCityId: number): void {
  const prefix = `${importedCityId}|`
  for (const k of memo.keys()) {
    if (k.startsWith(prefix)) memo.delete(k)
  }
}
